import * as React from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

// UI
import {
	Card,
	CardContent,
	CardDescription,
	CardFooter,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { PenLine, Camera, ArrowLeft } from "lucide-react";
export const Route = createFileRoute(
	"/_layout-private/account-management/soe/_information/general/$id",
)({
	component: RouteComponent,
});

function RouteComponent() {
	return "Hello /_layout-private/account-management/soe/_information/general/$id!";
}
